module.exports = __webpack_public_path__ + "ef2ee6c772637f51f56c94a09c6850b0.MP3";